var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reply-to-container",class:{
    'incoming-message': _vm.messageType === _vm.MESSAGE_TYPE.INCOMING,
    'outgoing-message': _vm.messageType === _vm.MESSAGE_TYPE.OUTGOING,
    'no-attachments': !_vm.parentHasAttachments,
  },on:{"click":_vm.scrollToMessage}},[_c('MessagePreview',{staticClass:"message-preview",attrs:{"message":_vm.message,"message-id":_vm.messageID,"show-message-type":true,"default-empty-message":_vm.$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }